export default class DataService {
  _data = {
    projectRepo: 'https://github.com/BrynnBateman/portfolio',
    react95Repo: 'https://github.com/React95/React95',
    items: [
      {
        id: 'about',
        name: 'About.txt',
        icon: 'info_bubble',
        parentId: 'desktop',
        content: {
          paragraphs: [
            "Hi, I'm Brynn. I've been immersed in software for most of my life, starting at age 11 with Liberty BASIC. My early days were spent building GeoCities sites to host GameBoy emulators and Pokémon ROMs - a passion that eventually evolved into higher-stakes professional work. Throughout my career, I've had the opportunity to build solutions for clients like Amazon, Salesforce, NetSuite, Oracle, and Goodwill.",
            "I've had a life-long love of RPGs, emulation, and deconstructing software, and it remains the center focus of many of my projects. Check out my Projects.txt!",
            "I'm always happy to discuss and take on new contract work, and especially if it's game dev related! I'm based in the Bay Area and open to collaborating in-person or remotely.",
            "https://github.com/brynnb",
            "contact2026@brynnbateman.com",
          ],
        },
      },
      {
        id: 'projects',
        name: 'Projects.txt',
        icon: 'flying_through_space_100',
        parentId: 'desktop',
        content: {
          projects: [
            {
              title: "IdleQuest",
              description: "A browser-based recreation of the 1999 MMORPG classic EverQuest, featuring a real-time MMO server written in Go, a 3D game client built with Babylon.js, and a faithfully recreated interface using React. I spent hundreds of hours extracting and implementing original game data and assets to recapture the look and feel of the original experience, while also adding lots of fun new \"idle\" mechanics so the game can optionally also play itself!",
              techStack: "React, Go, WebSockets, MySQL",
              url: "https://idlequest.net",
              repo: "https://github.com/brynnb/idlequest",
            },
            {
              title: "TerraSunder (Alpha)",
              description: "A browser-based recreation of the original PlanetSide 1 client, paired with extensions to an existing community-developed server emulator. The project aims to faithfully recapture the original game's graphics, gameplay, and massive multiplayer battles, bringing its sci-fi battlefields to the browser. Currently in active alpha development, with features and polish still in progress!",
              techStack: "Babylon.js, React, Vite, Havok",
              url: "https://terrasunder.net/play/",
            },
            {
              title: "New Yokosuka",
              description: "An online multiplayer recreation of Shenmue's Yokosuka built directly from original Dreamcast data. Custom parsers decode MT5 maps, characters, textures, animations, and scripted object placement into a shared Babylon.js world where players can explore the game's iconic neighborhoods together. The project also includes a browser-based asset viewer for inspecting the original models and environments.",
              techStack: "Babylon.js, JavaScript, Go, WebSockets, Cloudflare R2",
              url: "https://newyokosuka.com",
              repo: "https://github.com/brynnb/new-yokosuka",
            },
            {
              title: "Vanguard: Eternal Sagas",
              description: "A reverse-engineering and reimplementation of Vanguard: Saga of Heroes, an MMORPG from 2007 that was ultimately shut down in 2014. Built an extensive custom binary asset extractor that decodes the game's proprietary terrain, mesh, audio, texture, and data formats, then streams them live into both web-based and desktop game engines. With reverse engineering 95% complete and nearly all assets extracted, work continues on its integration into a playable world!",
              techStack: "Babylon.js, React, Python, Cloudflare R2",
              url: "https://eternalsagas.com/",
              repo: "https://github.com/brynnb/vanguard-saga-of-heroes-asset-extractor",
            },
            {
              title: "CaptureQuest",
              description: "An online multiplayer version of Pokemon Red/Blue, recreated from the original game data on the GameBoy cartridge! A simple proof of concept demo with real-time world interaction, monster collection, and trainer battles, all running in the browser with a custom Go server backend. Also includes a complete data extraction pipeline that parses original Game Boy Pokémon ROM assembly to pull out maps, sprites, encounters, and game logic for use in the web client.",
              techStack: "React, Phaser, Go, WebTransport, MySQL",
              url: "https://capturequest.net",
              repo: "https://github.com/brynnb/capture-quest",
            },
            {
              title: "Lucky Break",
              description: "A browser-based nine-ball pool game with a custom-built billiards physics engine, set inside Shenmue's MJQ Jazz Bar using assets extracted from the original 1999 Dreamcast game. It features complete nine-ball rules, computer-controlled opponents, detailed ball, cushion, and table interactions - and plenty of cheesy jazz music!",
              techStack: "TypeScript, Babylon.js, Vite, Custom Physics Engine",
              url: "https://luckybreak.app",
              repo: "https://github.com/brynnb/lucky-break",
            },
            {
              title: "DalaDose",
              description: "A specialized planning and analysis platform for radiation research. It lets researchers and clinicians review medical scans, visualize where radiation goes, define areas of interest, build treatment equipment in 3D, run scientific simulations, and compare results - all in one organized workspace. DalaDose is being developed with guidance from industry professionals and Stanford researchers.",
              techStack: "React, VTK.js, ITK.js, TOPAS",
              url: "https://daladose.com/",
            },
          ],
        },
      },
      {
        id: 'skills',
        name: 'Skills.txt',
        icon: 'progman_11',
        parentId: 'desktop',
        content: {
          hard: [
            {
              name: 'React',
              progress: 100,
            },
            {
              name: 'JavaScript',
              progress: 100,
            },
            {
              name: 'Node.js',
              progress: 90,
            },
          ],
          soft: 'Analytical thinking, Teamwork, Creative Problem solving',
        },
      },
      {
        id: 'contact',
        name: 'Contact.txt',
        icon: 'inetcfg_2301',
        parentId: 'desktop',
        content: {
          emailText:
            'If you want to hire me or invite to a project, just email me on ',
          email: 'contact2026@brynnbateman.com',
          socialText: 'Or you can reach me out through social media:',
          social: [
            {
              name: 'FaLinkedin',
              link: 'https://www.linkedin.com/in/brynn-bateman/',
            },
            {
              name: 'FaGithub',
              link: 'https://github.com/brynnb',
            },
          ],
        },
      },
      {
        id: 'more-stuff',
        name: 'More Stuff',
        icon: 'folder',
        type: 'folder'
      },
      {
        id: 'secret-stuff',
        name: 'Really Secret Stuff',
        icon: 'folder',
        type: 'folder',
        parentId: 'more-stuff'
      },
      {
        id: 'password-file',
        name: 'password.txt',
        icon: 'notepad_2',
        parentId: 'secret-stuff',
        content: { paragraphs: ['hunter2'] }
      },
    ],
    trash: [
      {
        id: 'resume-copy',
        name: 'resume copy.txt',
        icon: 'notepad_2',
        content: { paragraphs: ['Old version from 2022. Probably outdated.'] }
      },
      {
        id: 'resume-final',
        name: 'resume-copy-final.txt',
        icon: 'notepad_2',
        content: { paragraphs: ['Is this the one? No, wait.'] }
      },
      {
        id: 'resume-final-final',
        name: 'resume-copy-final-final.txt',
        icon: 'notepad_2',
        content: { paragraphs: ['I thought this was the final one.'] }
      },
      {
        id: 'resume-real',
        name: 'resume-final-FOR-REAL.txt',
        icon: 'notepad_2',
        content: { paragraphs: ['This time I mean it. Final.'] }
      }
    ]
  };

  getItems() {
    return this._data.items.map(({ id, name, icon }) => ({ id, name, icon }));
  }

  getTrashItems() {
    return this._data.trash.map(({ id, name, icon }) => ({ id, name, icon }));
  }

  getFolderItems(parentId) {
    if (!parentId) {
      // Main Stuff folder: items that don't have a parentId and aren't folders themselves OR are folders with no parent
      return this._data.items.filter(item => !item.parentId);
    }
    return this._data.items.filter(item => item.parentId === parentId);
  }

  getItem(id) {
    return [...this._data.items, ...this._data.trash].find((x) => x.id === id);
  }

  getProjectInfo() {
    return {
      projectRepo: this._data.projectRepo,
      react95Repo: this._data.react95Repo,
    };
  }
}
